/**
 * Different states for the proof-of-work widget regarding verification.
 * Values match the altcha-widget's state event detail strings.
 */
export enum ProofOfWorkVerificationState {
  /**
   * The widget has not yet started solving
   */
  idle = "unverified",

  /**
   * The widget is currently solving the proof-of-work challenge
   */
  challenging = "verifying",

  /**
   * The challenge was solved and the proof cookie has been set
   */
  verified = "verified",

  /**
   * An error occurred during solving
   */
  error = "error",
}
